export const ADDRS_SEARCH_START = 'ADDRS_SEARCH_START'
export const addrsSearchStart = (accountId, projectId, searchValue) => {
  return {
    type: ADDRS_SEARCH_START,
    accountId,
    projectId,
    searchValue
  }
}

export const ADDRS_SEARCH_SUCCESS = 'ADDRS_SEARCH_SUCCESS'
export const addrsSearchSuccess = foundAddresses => {
  return {
    type: ADDRS_SEARCH_SUCCESS,
    foundAddresses
  }
}

export const ADDRS_SEARCH_FAIL = 'ADDRS_SEARCH_FAIL'
export const addrsSearchFail = error => {
  return {
    type: ADDRS_SEARCH_FAIL,
    error
  }
}

export const SUGST_ADDRS_SEARCH = 'SUGST_ADDRS_SEARCH'
export const sugstAddrsSearch = (
  accountId,
  projectId,
  moduleName,
  recordId,
  addressType
) => {
  return {
    type: SUGST_ADDRS_SEARCH,
    accountId,
    projectId,
    moduleName,
    recordId,
    addressType
  }
}

export const SUGST_ADDRS_SEARCH_SUCCESS = 'SUGST_ADDRS_SEARCH_SUCCESS'
export const sugstAddrsSearchSuccess = suggestedAddresses => {
  return {
    type: SUGST_ADDRS_SEARCH_SUCCESS,
    suggestedAddresses
  }
}

export const SUGST_ADDRS_SEARCH_FAIL = 'SUGST_ADDRS_SEARCH_FAIL'
export const sugstAddrsSearchFail = error => {
  return {
    type: SUGST_ADDRS_SEARCH_FAIL,
    error
  }
}
